var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface22493397"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,23.921569%,0%)",
      fillOpacity: 1
    },
    d: "M 43.199219 33.898438 C 42.800781 36 41.101562 37.601562 39 37.898438 C 35.699219 38.398438 30.199219 39 24 39 C 17.898438 39 12.398438 38.398438 9 37.898438 C 6.898438 37.601562 5.199219 36 4.800781 33.898438 C 4.398438 31.601562 4 28.199219 4 24 C 4 19.800781 4.398438 16.398438 4.800781 14.101562 C 5.199219 12 6.898438 10.398438 9 10.101562 C 12.300781 9.601562 17.800781 9 24 9 C 30.199219 9 35.601562 9.601562 39 10.101562 C 41.101562 10.398438 42.800781 12 43.199219 14.101562 C 43.601562 16.398438 44.101562 19.800781 44.101562 24 C 44 28.199219 43.601562 31.601562 43.199219 33.898438 Z M 43.199219 33.898438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 20 31 L 20 17 L 32 24 Z M 20 31 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsYoutube);
export default __webpack_public_path__ + "static/media/icons_youtube.3d070bef44a8d03dfaf8c4e25798e0d5.svg";
export { ForwardRef as ReactComponent };